module.exports = __webpack_public_path__ + "static/new-coming-soon2.f5bfb927.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/people/new-coming-soon2.jpg
// module id = 1318
// module chunks = 168707334958949